var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "320px",
    height: "320px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6287 17.3715L19.2001 12.8",
    stroke: "#292929",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7714 7.3143C23.7714 7.81925 24.1807 8.22859 24.6857 8.22859H28.8784L24.307 12.8H19.2V7.69301L23.7714 3.12158V7.3143Z",
    stroke: "#292929",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6286 23.3143C17.9108 23.3143 20.5715 20.6536 20.5715 17.3714C20.5715 14.0893 17.9108 11.4286 14.6286 11.4286C11.3465 11.4286 8.68579 14.0893 8.68579 17.3714C8.68579 20.6536 11.3465 23.3143 14.6286 23.3143Z",
    stroke: "#292929",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6001 12.8C26.5143 14.1714 26.5143 16.4571 26.5143 17.3714C26.5143 23.9543 21.2115 29.2571 14.6286 29.2571C8.04578 29.2571 2.74292 23.9543 2.74292 17.3714C2.74292 10.7886 8.04578 5.48572 14.6286 5.48572C17.0058 5.48572 18.7429 5.94286 19.2001 6.4",
    stroke: "#292929",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.09592882ee269d2149c0af1f90ad1bb6.svg";
export { ForwardRef as ReactComponent };